import { PluginRef } from "gatsby";
import { isPresent } from "../utils/checks";

type HostingPlatform = "unknown" | "netlify" | "dockerPreview";

export const envVariableTrue = (envVariable: string | undefined): boolean => {
  return (envVariable || "false").toLowerCase() === "true";
};

export const isProduction = process.env.NODE_ENV === "production";

export const currentHostingPlatform = (): HostingPlatform => {
  if (envVariableTrue(process.env.NETLIFY)) return "netlify";

  if (envVariableTrue(process.env.DOCKER_GATSBY_IS_PREVIEW))
    return "dockerPreview";

  return "unknown";
};

export const shouldEnableDraft = (
  hostingPlatform: HostingPlatform
): boolean => {
  if (!isPresent(process.env.SANITY_API_TOKEN)) return false;

  // if docker or gatsby cloud preview, then enable draft
  if (["gatsbyCloudPreview", "dockerPreview"].includes(hostingPlatform))
    return true;

  // if in dev mode enable draft
  if (hostingPlatform == "unknown" && !isProduction) return true;

  return false;
};

export const onHostingPlatform = (
  enabledForHostingPlatform: HostingPlatform,
  config: PluginRef[]
): PluginRef[] => {
  const platform = currentHostingPlatform();
  if (enabledForHostingPlatform == platform) return config;

  return [];
};
